import { StatCard } from "@components/stat-card";
import type { StatCardConfig } from "@hooks/use-reports/types";
import { ICON_MAP } from "./reporting-constants";

export interface StatCardsSectionProps {
  statCardsData: Record<string, number>;
  statCardDefinitions: readonly StatCardConfig[];
}

export const StatCardsSection = ({ statCardsData, statCardDefinitions }: StatCardsSectionProps) => {
  // Map colors to valid StatCard colors (secondary -> primary)
  const getValidColor = (color?: string): "primary" | "success" | "warning" | "error" | "info" => {
    if (color === "secondary") return "primary";
    if (["primary", "success", "warning", "error", "info"].includes(color as string)) {
      return color as "primary" | "success" | "warning" | "error" | "info";
    }
    return "primary";
  };

  return (
    <div className="stat-cards-row">
      {statCardDefinitions?.map((statCard) => {
        const IconComponent = ICON_MAP[statCard.icon as string];
        const value = statCardsData[statCard.id] ?? 0;

        return (
          <StatCard
            key={statCard.id}
            title={statCard.title}
            value={value}
            icon={IconComponent ? <IconComponent fontSize="large" /> : undefined}
            color={getValidColor(statCard.color)}
            prefix={statCard.prefix}
            suffix={statCard.suffix}
            tooltip={statCard.tooltip}
          />
        );
      })}
    </div>
  );
};
